module.exports = __webpack_public_path__ + "static/img/客户案例-002.f4d29ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cases/客户案例-002.png
// module id = tdRo
// module chunks = 94